import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AddComponent = ({ apiEndpoint, onSuccess, onClose }) => {
  const [formData, setFormData] = useState({
    CategoryID: "",
    ItemName: "",
    Description: "",
    AccountingUnitID: "",
  });

  const [dropdowns, setDropdowns] = useState({
    categories: [],
    maus: [],
  });

  const enteredBy = useSelector((state) => state.auth.id);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [categories, maus] = await Promise.all([
          axios.get(`${API_BASE_URL}/dropdown/mcatdrop`),
          axios.get(`${API_BASE_URL}/dropdown/maudrop`),
        ]);
        setDropdowns({
          categories: categories.data,
          maus: maus.data,
        });
      } catch (err) {
        setError("Failed to fetch dropdown data.");
      }
    };
    fetchDropdownData();
  }, [apiEndpoint]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    console.log(formData); 


    try {
      await axios.post(apiEndpoint, { ...formData, EnteredBy: enteredBy });

      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add item.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow-md">
      <h2 className="text-lg font-semibold">Add New Item</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">

        <select
          name="CategoryID"
          value={formData.CategoryID}
          onChange={handleChange}
          className="border rounded px-4 py-2"
          required
        >
          <option value="">Select Category</option>
          {dropdowns.categories.map((cate) => (
            <option key={cate.CategoryID} value={cate.CategoryID}>
              {cate.CategoryName}
            </option>
          ))}
        </select>
        <input
          type="text"
          name="ItemName"
          value={formData.ItemName}
          onChange={handleChange}
          placeholder="Item Name"
          className="border rounded px-4 py-2"
          required
        />
                <input
          type="text"
          name="Description"
          value={formData.Description}
          onChange={handleChange}
          placeholder="Description"
          className="border rounded px-4 py-2"
          required
        />
        <select
          name="AccountingUnitID"
          value={formData.AccountingUnitID}
          onChange={handleChange}
          className="border rounded px-4 py-2"
          required
        >
          <option value="">Select Unit</option>
          {dropdowns.maus.map((mau) => (
            <option key={mau.AccountingUnitID} value={mau.AccountingUnitID}>
              {mau.UnitName}
            </option>
          ))}
        </select>
        <div className="flex gap-4">
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded"
            disabled={loading}
          >
            {loading ? "Adding..." : "Add"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddComponent;
